import React from 'react';

const ConfigDebug = () => {
  // Only show in development mode
  if (import.meta.env.PROD) return null;

  const config = {
    environment: import.meta.env.VITE_APP_ENV || 'unknown',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'not-configured',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'not-configured',
    hasApiKey: import.meta.env.VITE_FIREBASE_API_KEY ? '✅ Set' : '❌ Missing',
    hasAppId: import.meta.env.VITE_FIREBASE_APP_ID ? '✅ Set' : '❌ Missing'
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: '8px',
      right: '8px',
      background: 'rgba(0,0,0,0.75)',
      color: 'white',
      padding: '6px 10px',
      borderRadius: '6px',
      fontSize: '11px',
      fontFamily: 'monospace',
      zIndex: 9999,
      maxWidth: '220px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.3)'
    }}>
      <div style={{ fontWeight: 'bold', marginBottom: '4px', fontSize: '12px' }}>🔧 Config</div>
      <div>Env: <strong>{config.environment}</strong></div>
      <div>Project: <strong>{config.projectId}</strong></div>
    </div>
  );
};

export default ConfigDebug;